import React from "react"
import PropTypes from "prop-types"
import css from "./Skeleton.scss"

const MAX_SPAN = 12

function Skeleton({ config, isComponent, wrappedInCol, passedAsProps }) {
    const skeletonContent = (
        <div className={isComponent ? "" : "container-fluid"}>
            <div className="flex flexColumn">{getBlocks(config || [], wrappedInCol)}</div>
        </div>
    )

    // react-loadable-visibility adds a div around fallbacks on the client. So we also need to wrap fallbacks with a div on sever.
    // When we pass fallbacks as an option while importing the widgets the library handles this for us, but when we give fallbacks AS PROPS we need to add this div around fallbacks manually on the SERVER ONLY.

    if (passedAsProps) {
        if (typeof window !== "undefined") return skeletonContent
        else return <div>{skeletonContent}</div>
    } else return skeletonContent
}

function getBlocks(config, wrappedInCol) {
    let blocks = []
    for (const [index, row] of config.entries()) {
        const { height, classes = "", columns = [] } = row
        /*
         * If row has a span, give it first preference
         * Else if no child columns are present, default to MAX_SPAN
         */
        const span = row.span || (!columns.length && MAX_SPAN)
        /**
         * The prop "wrappedInCol" is used for the cases where component is already wrapped in "col" class
         */
        const spanClass = span && !wrappedInCol ? `col-${span}` : ""
        if (columns.length) {
            blocks.push(
                <div key={index} className={`flex ${classes} ${spanClass}`} style={{ height: height }}>
                    {getColumns(columns, index)}
                </div>
            )
        } else
            blocks.push(
                <div
                    key={index}
                    className={`${classes} ${spanClass} ${css.divStyle}`}
                    style={{ height: height }}
                />
            )
    }
    return blocks
}

function getColumns(columns, parentIndex) {
    let blocks = []
    for (const [index, column] of columns.entries()) {
        const { span, height, classes, rows = [] } = column
        let colSpanClass = `col-${span}`
        if (!span) {
            //transformd to new log format
            console.dir({
                service_name: "pwa-dweb-node-server",
                loglevel: "info",
                version: "v2",
                message: "\n Warning: Column span is missing \n ",
            })
            colSpanClass = ""
        }
        if (rows.length) {
            blocks.push(
                <div
                    key={`${parentIndex}_${index}`}
                    className={`${classes ? classes : "flex flexColumn"} ${colSpanClass}`}
                    style={{ height: height }}
                >
                    {getRows(rows, `${parentIndex}_${index}`)}
                </div>
            )
        } else
            blocks.push(
                <div
                    key={`${parentIndex}_${index}`}
                    className={`${classes ? classes : ""} ${colSpanClass} ${css.divStyle}`}
                    style={{ height: height }}
                />
            )
    }
    return blocks
}

function getRows(rows, parentIndex) {
    let blocks = []
    for (let [index, row] of rows.entries()) {
        const { span, height, classes = "" } = row
        const rowSpanClass = span ? `col-${span}` : ""
        blocks.push(
            <div
                key={`${parentIndex}_${index}`}
                className={`${classes} ${rowSpanClass} ${css.divStyle}`}
                style={{ height: height }}
            />
        )
    }
    return blocks
}

Skeleton.propTypes = {
    config: PropTypes.array.isRequired,
    isComponent: PropTypes.bool,
    wrappedInCol: PropTypes.bool,
    passedAsProps: PropTypes.bool,
}

export default Skeleton
